import { render, staticRenderFns } from "./PermisosCierrePqr.vue?vue&type=template&id=000314f6&scoped=true"
import script from "./PermisosCierrePqr.vue?vue&type=script&lang=js"
export * from "./PermisosCierrePqr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000314f6",
  null
  
)

export default component.exports